import { useEffect, useState } from 'react';
import axios from 'axios';
import Table from 'react-bootstrap/Table';
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { SiMicrosoftexcel } from "react-icons/si";

function BasicExample() {
  const [sortedTipo_cliData, setSortedTipo_cliData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get("./dati_dashboard.json");
        const tipo_cliData = response.data?.AR?.tipo_cli || [];

        const transformedData = tipo_cliData.map(item => ({
          tipo_cliente: item.tipo_cliente,
          valore: parseFloat(item.valore).toFixed(2),
          numero: parseInt(item.numero),
          origine: item.origine,
        }));

        const sortedData = transformedData.sort((a, b) =>
          parseFloat(b.valore) - parseFloat(a.valore)
        );

        setSortedTipo_cliData(sortedData);
      } catch (error) {
        console.error('Error fetching data from the server:', error);
      }
    };

    fetchData();
  }, []);

  const formatToEuro = (amount) => {
    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'EUR',
    }).format(amount);
  };

  const exportToExcel = () => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileName = "tipo_cli.xlsx";
    const data = sortedTipo_cliData.map((tipo_cliItem) => ({
      Cliente: tipo_cliItem.tipo_cliente,
      Valore: tipo_cliItem.valore,
      Numero: tipo_cliItem.numero,
    }));

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const excelData = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(excelData, fileName);
  };


  return (
    <div className='bg-secondary widget-client2 ombra tb hover-effect'>
      <Table className='bg-secondary' hover style={{fontSize: '0.8rem', borderRadius: '25px'}}>
        <thead >
          <tr>
            <th  style={{backgroundColor: 'rgba(241,111,36,1)'}} className='sticky-top'>Tipo Cliente</th>
            <th  style={{backgroundColor: 'rgba(241,111,36,1)'}} className='sticky-top'>Valore</th>
            <th  style={{backgroundColor: 'rgba(241,111,36,1)'}} className='sticky-top'>Numero</th>
            <th className="bg-success text-light" style={{width: '6%'}} onClick={exportToExcel}><SiMicrosoftexcel className="fs-5 excel"/></th>

          </tr>
        </thead>
        <tbody>
          {sortedTipo_cliData.map((tipo_cliItem, index) => (
            <tr key={index}>
              <td className='bg-secondary text-light'>{tipo_cliItem.tipo_cliente}</td>
              <td className='bg-secondary text-light'>{formatToEuro(tipo_cliItem.valore)}</td>
              <td className='bg-secondary text-light'>{tipo_cliItem.numero}</td>
              <td className='bg-secondary text-light'></td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}



export default BasicExample;
